export default __webpack_public_path__ + "static/media/navbg.f78825b5.jpg";